import { createFileRoute } from "@tanstack/react-router";
import { useParams } from "@/lib/navigation";
import { ComplianceAdmin } from "@/components/Compliance/Admin";

function RouteComponent() {
  const params = useParams();
  const id = params?.id as string;

  return <ComplianceAdmin id={id} />;
}

export const Route = createFileRoute("/_authenticated/compliance/$id/")({
  component: RouteComponent,
  staticData: { page: "compliance" },
});
